export default {
  error: null,
  loading: false,
  records: [],
};
